// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUs_aboutUs__1B9N4"};